export const ExportAction = ({ onExport }) => ({
  label: "Export",
  icon: "export-sheet",
  onClickBulk: onExport,
  confirm: {
    title: "Export Reservations",
    message: (selection = []) =>
      `Export ${selection.length} selected reservation${
        selection.length === 1 ? "" : "s"
      }?`,
    confirmLabel: "Export",
  },
})

export const SendMessageAction = ({ onClickSingle, onClickBulk }) => ({
  label: "Send Message",
  icon: "md-mail",
  onClickSingle,
  onClickBulk,
})
